import { __extends } from "tslib";
import { GetEndpointRequest, GetEndpointResponse } from "../models/models_0";
import { deserializeAws_restJson1GetEndpointCommand, serializeAws_restJson1GetEndpointCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetEndpointCommand = /** @class */ (function (_super) {
    __extends(GetEndpointCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetEndpointCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetEndpointCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "GetEndpointCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: GetEndpointRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetEndpointResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetEndpointCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1GetEndpointCommand(input, context);
    };
    GetEndpointCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1GetEndpointCommand(output, context);
    };
    return GetEndpointCommand;
}($Command));
export { GetEndpointCommand };
//# sourceMappingURL=GetEndpointCommand.js.map